/* Policies content — scrollspy: highlight the in-view section's link in .pindex */
(function () {
  if (!('IntersectionObserver' in window)) return;
  document.querySelectorAll('.s-policies-content').forEach(function (root) {
    var links = Array.prototype.slice.call(root.querySelectorAll('.pindex a'));
    if (!links.length) return;
    var secs = links.map(function (a) {
      return root.querySelector(a.getAttribute('href'));
    });
    var io = new IntersectionObserver(
      function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (l) {
            l.classList.remove('active');
          });
          var i = secs.indexOf(en.target);
          if (i > -1) links[i].classList.add('active');
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    secs.forEach(function (sct) {
      if (sct) io.observe(sct);
    });
  });
})();
